"use client";

import { Badge } from "@/components/ui/badge";
import { Popover, Group, ScrollArea, Stack, Text } from "@mantine/core";
import { TagBadgeItem } from "./TagBadgeItem";

interface HiddenTagsPopoverProps {
  hiddenTags: string[];
  hiddenCount: number;
  isLoading: boolean;
  popoverOpened: boolean;
  onTogglePopover: () => void;
  onClosePopover: () => void;
  onRemove: (tag: string) => void;
}

export function HiddenTagsPopover({
  hiddenTags,
  hiddenCount,
  isLoading,
  popoverOpened,
  onTogglePopover,
  onClosePopover,
  onRemove,
}: HiddenTagsPopoverProps) {
  return (
    <Popover
      position="bottom"
      withArrow
      shadow="md"
      opened={popoverOpened}
      onClose={onClosePopover}
    >
      <Popover.Target>
        <Badge
          variant="outline"
          className="text-xs font-medium bg-card-50 text-gray-600 border-gray-200 cursor-pointer hover:bg-gray-100 dark:text-gray-400 dark:border-gray-700 dark:hover:bg-gray-800 transition-colors"
          onClick={onTogglePopover}
        >
          +{hiddenCount} more
        </Badge>
      </Popover.Target>
      <Popover.Dropdown>
        <Stack gap="xs" style={{ maxWidth: 350 }}>
          <Text size="sm" fw={600}>
            Remaining Tags ({hiddenCount})
          </Text>
          <ScrollArea style={{ maxHeight: 300 }}>
            <Group gap="xs" wrap="wrap">
              {hiddenTags.map((tag) => (
                <TagBadgeItem key={tag} tag={tag} isLoading={isLoading} onRemove={onRemove} />
              ))}
            </Group>
          </ScrollArea>
        </Stack>
      </Popover.Dropdown>
    </Popover>
  );
}
